import {Injectable} from '@angular/core';

declare const Yiit;

@Injectable({providedIn: 'root'})
export class YiitService {
  translate(text: string, params?: string[]): string {
    const translation: string = Yiit.t(text, params);
    return this.unescape(translation);
  }

  private unescape(text: string): string {
    const el: HTMLDivElement = document.createElement('div');
    /**
     * Don't worry about XSS:
     * https://developer.mozilla.org/en-US/docs/Web/API/Element/innerHTML#security_considerations
     */
    el.innerHTML = text;
    return el.textContent;
  }
}
